import React from 'react';
import { Paper, Typography, ButtonBase } from '@material-ui/core';

const Cartao = props => {
    const { onClick, titulo, subtitulo, valor, valorIdeal } = props;
    const bgColor = ((valorIdeal === 0 && valor > 0) || (valorIdeal > 0 && valor <= 0) || (valorIdeal < 0 && valor >= 0)) ? '#ffedb0' : '#FFF';

    return (
        <ButtonBase onClick={onClick} style={{ display: 'block', width: '100%' }}>
            <Paper
                elevation={2}
                variant='outlined'
                square
                style={{
                    padding: '10px',
                    textAlign: 'center',
                    margin: '10px',
                    backgroundColor: bgColor

                }}
            >
                <Typography variant='h3'>{valor}</Typography>
                <Typography variant='body2'>{titulo}</Typography>
                <Typography variant='subtitle2'>{subtitulo}</Typography>
            </Paper>
        </ButtonBase>
    )
}

export default Cartao